async function getAgencyConfig(that,fun){
    if(sessionStorage.getItem("agencyconfig")&&sessionStorage.getItem("agencyconfig")!=""){
        that.$store.commit("SETCONFIGFIELD", JSON.parse(sessionStorage.getItem("agencyconfig")));
    }
    let headinfo = {};
    await that.asyncaxiosInvoke("/AgencyComm/Handler/VueSysHandler.ashx",
    {action:"getagencyconfig"},
    (res)=>{
        let ay = new Array();
        var data = res.data;
        // if(data.GenrateDifferentTypes != 'undefined') {                    
        //     ay.push({"GenrateDifferentTypes":data.GenrateDifferentTypes});
        if(ay != '' && ay.length > 0){
            sessionStorage.setItem("agencyconfig",JSON.stringify(ay));
            that.$store.commit("SETCONFIGFIELD", ay);
        }
        if(fun){
            fun();
        }
        headinfo = data.headinfo;
    }
    )
    return headinfo;
}
export {
    getAgencyConfig
}